import React, { Component } from 'react';

// LoadingSpinner Component
class LoadingSpinner extends Component {

  render() {
    return(
      <i
        className="fa fa-sync fa-4x fa-spin"
        style={{ margin: '20px' }}
      />
    )
  }
}
export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner.js